import { z } from 'zod';

export const anamnesisSubjectItemSchema = z.object({
  id: z.string(),
  label: z.string(),
  type: z.string(),
  order_index: z.number(),
  value: z.string().nullable(),
});

export const anamnesisSubjectSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  order_index: z.number(),
  items: z.array(anamnesisSubjectItemSchema),
});

export const anamnesisSchema = z.object({
  id: z.string(),
  patient_id: z.string(),
  subjects: z.array(anamnesisSubjectSchema),
  created_at: z.string(),
  updated_at: z.string().nullable(),
});

export type Anamnesis = z.infer<typeof anamnesisSchema>;
export type AnamnesisSubject = z.infer<typeof anamnesisSubjectSchema>;
export type AnamnesisSubjectItem = z.infer<typeof anamnesisSubjectItemSchema>;
